import React from "react";
import { Form, Col, Row } from "react-bootstrap";

function InputContainer({
  children,
  label,
  colSize,
  style,
  labelSize,
  onLabelClick = null,
  labelClassName,
  rowStyle,
  ignoreColPadding = false,
}) {
  return (
    <div style={{ ...style }}>
      <Form.Group
        as={Row}
        style={{ alignItems: "center", marginBottom: "0.5rem", ...rowStyle }}
      >
        {label && (
          <Form.Label
            className={`${labelClassName ?? "pl-4 d-flex"}`}
            column
            sm={"12"}
            md={labelSize || "2"}
            xs={"12"}
            style={{
              paddingTop: "0px",
              paddingRight: "0px",
              paddingBottom: "0px",
              wordBreak: "break-word",
              cursor: `${onLabelClick ? "pointer" : "default"}`,
            }}
            onClick={onLabelClick}
          >
            {label}
          </Form.Label>
        )}
        {!ignoreColPadding ? (
          <Col sm={"12"} md={colSize || "8"} xs={"12"} className="pr-10">
            {children}
          </Col>
        ) : (children)}
      </Form.Group>
    </div>
  );
}

export default InputContainer;
